<!--
 * @Description: 星图商城列表
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2022-11-25 14:32:16
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 -->
<template>
  <div class="shoplist">
    <div class="shoplist-box">
      <div
        class="shop"
        v-for="item in this.data_show"
        :key="item.id"
        @click="handleJump(item.id,item.targetUrl)"
      >
        <div class="bigImg">
          <img
            :src="
              `${baseUrlAddr}/front/picUploadAndDownload/download3?fileName=` +
              item.picture
            "
          />
        </div>
        <div class="shop_name">
          <b>{{ item.name }}</b>
        </div>
        <div class="shop_introduce">{{ item.pictureDescribe }}</div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentchange"
          :page-size="this.pageSize"
          :total="this.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //把路由设置的缓存改为不缓存
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
  data() {
    return {
      currentPage: 1, //默认当前页
      pageSize: 24, //每页多少
      pageNum: 1, //共几页
      data_show: [], //当前页的数据
      total: 0, //总共多少条数据
      
    };
  },
  created() {
    //初始化当前分页显示数据
    this.handleGetInfo();
  },
  mounted() {},
  methods: {
    //获取后台数据
    handleGetInfo() {
      this.request
        .post("/front/device/product/findPage", {
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((res) => {
          console.log("zzx", res);
          this.data_show = res.data;

          this.total = res.total;
        });
    },
    // handleGetInfo() {
    //   this.data_show=this.data.slice((this.pageSize*(this.currentPage-1)),this.pageSize*this.currentPage)
    // },

    // handleSizechange(size) {
    //   this.pageSize = size;
    //   this.handleGetInfo();
    // },

    //页码变化时触发
    handleCurrentchange(currentPage) {
      this.currentPage = currentPage;
      this.handleGetInfo();
    },
    //点击商品跳转详情页
    handleJump(id,targetUrl) {
      this.$router.push({
        path: "/ShopDetails",
        query: {
          id: id,
          targetUrl: targetUrl
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.shoplist {
  margin: 0;
  padding: 0;
  list-style: none;

  .shoplist-box {
    padding: 0 0 0 10px;
    box-sizing: border-box;

    overflow: hidden;

    .shop {
      float: left;
      width: 200px;
      height: 250px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      padding: 16px 0 0 0;
      box-sizing: border-box;
      margin-bottom: 8px;
      margin-right: 9px;
      box-shadow: 0px 0px 11px 1px rgba(0, 0, 0, 0.08);
      .bigImg :hover {
        transform: scale(1.2);
      }
      img {
        width: 120px;
        height: 120px;
      }
      .shop_name {
        font-size: 12px;
        margin: 40px 0 8px 0;
      }
      .shop_introduce {
        width: 145px;
        font-size: 12px;
        color: #b0b0b0;
        margin-left: 25px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }
    .pagination {
      position: absolute;
      bottom: 50px;
      left: 40%;
    }
  }
}
</style>
